// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-2xl);
  z-index: 1000;
}

.modal {
  width: 100%;
  max-width: 680px;
  background: var(--color-bg-surface);
  border-radius: 20px;
  box-shadow: var(--shadow-modal);
  border: 1px solid var(--color-border-default);
  overflow: hidden;
}

.modal--settings {
  max-width: 720px;
}

.modal--confirm {
  max-width: 420px;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-xl);
  border-bottom: 1px solid var(--color-border-divider);
}

.modal-title {
  font-size: 28px;
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
  margin: 0;
}

.modal-close {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color var(--transition-fast);
}

.modal-close img {
  width: 16px;
  height: 16px;
}

.modal-close:hover {
  background: var(--color-bg-hover);
}

.modal-body {
  padding: var(--spacing-xl);
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: var(--spacing-md);
  padding: var(--spacing-xl);
  border-top: 1px solid var(--color-border-divider);
}

.modal-form {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}

.modal-label {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-primary);
  margin-bottom: var(--spacing-sm);
}

.modal-input {
  width: 100%;
  padding: 12px 14px;
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border-default);
  font-size: var(--font-size-base);
  outline: none;
  background: var(--color-bg-surface);
  color: var(--color-text-primary);
}

.modal-input::placeholder {
  color: var(--color-text-muted);
}

.modal-input--error {
  border-color: var(--color-danger, #ef4444);
}

.modal-error {
  font-size: var(--font-size-sm);
  color: var(--color-danger, #ef4444);
  display: none;
}

.modal-error--visible {
  display: block;
}

.modal-message {
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  margin: 0;
}

.modal-btn {
  padding: 8px 18px;
  border-radius: var(--radius-full);
  border: 1px solid var(--color-border-default);
  background: transparent;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: background-color var(--transition-fast), border-color var(--transition-fast);
  color: var(--color-text-primary);
}

.modal-btn--primary {
  background: var(--color-primary);
  border-color: transparent;
  color: #ffffff;
}

.modal-btn--primary:hover {
  background: var(--color-primary-hover);
}

.modal-btn--danger {
  background: var(--color-error);
  border-color: var(--color-error);
  color: #ffffff;
}

.modal-btn--danger:hover {
  background: #dc2626;
}

.settings-section {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}

.settings-section__label {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-sm);
  font-size: var(--font-size-sm);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-text-secondary);
  font-weight: var(--font-weight-semibold);
  margin-bottom: 14px;
}

.settings-section__label img {
  width: 18px;
  height: 18px;
}

.settings-theme {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--spacing-md);
}

.settings-pill {
  padding: 10px 16px;
  border-radius: var(--radius-full);
  border: 1px solid var(--color-border-default);
  background: transparent;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  color: var(--color-text-primary);
}

.settings-pill.is-active {
  background: var(--color-primary);
  color: #ffffff;
  border-color: transparent;
}

[data-theme="light"] #theme-pill-dark:not(.is-active) {
  color: #111111;
}

[data-theme="light"] .settings-pill.is-active {
  color: #ffffff;
}

.settings-divider {
  height: 1px;
  background: var(--color-border-divider);
  margin: var(--spacing-xl) 0;
}

.settings-action {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-md);
  padding: 12px 16px;
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border-default);
  background: transparent;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: background-color var(--transition-fast);
  color: var(--color-text-primary);
}

.settings-action img {
  width: 20px;
  height: 20px;
}

.settings-action:hover {
  background: var(--color-bg-hover);
}

.settings-action--danger {
  color: var(--color-error);
  border-color: rgba(239, 68, 68, 0.4);
}

.settings-action--danger:hover {
  background: rgba(239, 68, 68, 0.08);
}

.settings-file-input {
  display: none;
}

.settings-about {
  display: grid;
  gap: var(--spacing-sm);
  font-size: var(--font-size-base);
  color: var(--color-text-secondary);
}

.settings-about__row {
  display: flex;
  justify-content: space-between;
  gap: var(--spacing-lg);
  color: var(--color-text-secondary);
}

[data-theme="dark"] .modal-close img,
[data-theme="dark"] .settings-section__label img,
[data-theme="dark"] .settings-action img {
  filter: invert(1);
}

body.modal-open {
  overflow: hidden;
}

@media (max-width: 720px) {
  .modal {
    max-width: 100%;
  }

  .settings-theme {
    grid-template-columns: 1fr;
  }

  .modal-footer {
    flex-direction: column;
    align-items: stretch;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/modal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,+BAA+B;EAC/B,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;EACtC,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,6CAA6C;EAC7C,gCAAgC;EAChC,aAAa;EACb,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,6CAA6C;EAC7C,uBAAuB;EACvB,gCAAgC;EAChC,sCAAsC;EACtC,eAAe;EACf,wFAAwF;EACxF,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,6CAA6C;EAC7C,uBAAuB;EACvB,gCAAgC;EAChC,sCAAsC;EACtC,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;EAC/B,6CAA6C;EAC7C,uBAAuB;EACvB,gCAAgC;EAChC,sCAAsC;EACtC,eAAe;EACf,mDAAmD;EACnD,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF","sourcesContent":[".modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-2xl);\n  z-index: 1000;\n}\n\n.modal {\n  width: 100%;\n  max-width: 680px;\n  background: var(--color-bg-surface);\n  border-radius: 20px;\n  box-shadow: var(--shadow-modal);\n  border: 1px solid var(--color-border-default);\n  overflow: hidden;\n}\n\n.modal--settings {\n  max-width: 720px;\n}\n\n.modal--confirm {\n  max-width: 420px;\n}\n\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--spacing-xl);\n  border-bottom: 1px solid var(--color-border-divider);\n}\n\n.modal-title {\n  font-size: 28px;\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-primary);\n  margin: 0;\n}\n\n.modal-close {\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  border-radius: var(--radius-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color var(--transition-fast);\n}\n\n.modal-close img {\n  width: 16px;\n  height: 16px;\n}\n\n.modal-close:hover {\n  background: var(--color-bg-hover);\n}\n\n.modal-body {\n  padding: var(--spacing-xl);\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--spacing-md);\n  padding: var(--spacing-xl);\n  border-top: 1px solid var(--color-border-divider);\n}\n\n.modal-form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-md);\n}\n\n.modal-label {\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-medium);\n  color: var(--color-text-primary);\n  margin-bottom: var(--spacing-sm);\n}\n\n.modal-input {\n  width: 100%;\n  padding: 12px 14px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--color-border-default);\n  font-size: var(--font-size-base);\n  outline: none;\n  background: var(--color-bg-surface);\n  color: var(--color-text-primary);\n}\n\n.modal-input::placeholder {\n  color: var(--color-text-muted);\n}\n\n.modal-input--error {\n  border-color: var(--color-danger, #ef4444);\n}\n\n.modal-error {\n  font-size: var(--font-size-sm);\n  color: var(--color-danger, #ef4444);\n  display: none;\n}\n\n.modal-error--visible {\n  display: block;\n}\n\n.modal-message {\n  font-size: var(--font-size-base);\n  color: var(--color-text-primary);\n  margin: 0;\n}\n\n.modal-btn {\n  padding: 8px 18px;\n  border-radius: var(--radius-full);\n  border: 1px solid var(--color-border-default);\n  background: transparent;\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-medium);\n  cursor: pointer;\n  transition: background-color var(--transition-fast), border-color var(--transition-fast);\n  color: var(--color-text-primary);\n}\n\n.modal-btn--primary {\n  background: var(--color-primary);\n  border-color: transparent;\n  color: #ffffff;\n}\n\n.modal-btn--primary:hover {\n  background: var(--color-primary-hover);\n}\n\n.modal-btn--danger {\n  background: var(--color-error);\n  border-color: var(--color-error);\n  color: #ffffff;\n}\n\n.modal-btn--danger:hover {\n  background: #dc2626;\n}\n\n.settings-section {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-md);\n}\n\n.settings-section__label {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  font-size: var(--font-size-sm);\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--color-text-secondary);\n  font-weight: var(--font-weight-semibold);\n  margin-bottom: 14px;\n}\n\n.settings-section__label img {\n  width: 18px;\n  height: 18px;\n}\n\n.settings-theme {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--spacing-md);\n}\n\n.settings-pill {\n  padding: 10px 16px;\n  border-radius: var(--radius-full);\n  border: 1px solid var(--color-border-default);\n  background: transparent;\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-medium);\n  cursor: pointer;\n  color: var(--color-text-primary);\n}\n\n.settings-pill.is-active {\n  background: var(--color-primary);\n  color: #ffffff;\n  border-color: transparent;\n}\n\n[data-theme=\"light\"] #theme-pill-dark:not(.is-active) {\n  color: #111111;\n}\n\n[data-theme=\"light\"] .settings-pill.is-active {\n  color: #ffffff;\n}\n\n.settings-divider {\n  height: 1px;\n  background: var(--color-border-divider);\n  margin: var(--spacing-xl) 0;\n}\n\n.settings-action {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-md);\n  padding: 12px 16px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--color-border-default);\n  background: transparent;\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-medium);\n  cursor: pointer;\n  transition: background-color var(--transition-fast);\n  color: var(--color-text-primary);\n}\n\n.settings-action img {\n  width: 20px;\n  height: 20px;\n}\n\n.settings-action:hover {\n  background: var(--color-bg-hover);\n}\n\n.settings-action--danger {\n  color: var(--color-error);\n  border-color: rgba(239, 68, 68, 0.4);\n}\n\n.settings-action--danger:hover {\n  background: rgba(239, 68, 68, 0.08);\n}\n\n.settings-file-input {\n  display: none;\n}\n\n.settings-about {\n  display: grid;\n  gap: var(--spacing-sm);\n  font-size: var(--font-size-base);\n  color: var(--color-text-secondary);\n}\n\n.settings-about__row {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--spacing-lg);\n  color: var(--color-text-secondary);\n}\n\n[data-theme=\"dark\"] .modal-close img,\n[data-theme=\"dark\"] .settings-section__label img,\n[data-theme=\"dark\"] .settings-action img {\n  filter: invert(1);\n}\n\nbody.modal-open {\n  overflow: hidden;\n}\n\n@media (max-width: 720px) {\n  .modal {\n    max-width: 100%;\n  }\n\n  .settings-theme {\n    grid-template-columns: 1fr;\n  }\n\n  .modal-footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
